import Paginator from '../components/common/Paginator.vue'


export const paginatorMixin = {
    components: {
        Paginator
    },
    data() {
        return {
            pageSize: 20,
            pages: 1,
            page: 1,
            total: 0
        }
    },
    computed: {
        totalPages: function () {
            return Math.ceil(this.total / this.pageSize);
        }
    },
    methods: {
        changePage(p) {
            this.page = p;
        },
        changePageSize(pageSize) {
            this.page = 1;
            this.pageSize = pageSize;
        }
    }
};



// WEBPACK FOOTER //
// ./src/util/paginatorMixin.js